const dev_mode = {
  //   BASE_URL: 'http://localhost:7777/school',
  BASE_URL: '/api',
  DEFAULT_IMAGE: 'https://www.w3schools.com/w3images/avatar2.png',
};

const http_config = dev_mode;
export default http_config;
